import script from "./ai-review-accept-button.vue?vue&type=script&setup=true&lang=ts"
export * from "./ai-review-accept-button.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__